<template>
    <v-content class="grey lighten-4 pa-0">
        <header-component/>
        <business-unit-panel></business-unit-panel>
        <date-time-panel></date-time-panel>
        <filters-panel></filters-panel>
        <v-container fluid>
            <searchbar-component/>
            <filters-component/>
            <action-filters-component/>
            <results-component/>
        </v-container>
    </v-content>
</template>

<script>
    import HeaderComponent from "@/components/HeaderComponent"
    import SearchbarComponent from "@/components/home/SearchbarComponent"
    import FiltersComponent from "@/components/home/filter/FiltersDisplay"
    import ActionFiltersComponent from "@/components/home/ActionFiltersComponent"
    import ResultsComponent from "@/components/home/ResultsComponent"

    import BusinessUnitPanel from "@/components/home/BusinessUnitPanel"
    import DateTimePanel from "@/components/home/date/DateTimePanel"
    import FiltersPanel from "@/components/home/filter/FiltersPanel"
    import {decodeAsJsonUriParams} from "@/router/routeParamsHelper";
    import {mapActions} from "vuex";
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import moment from "moment";

    export default {
        components: {
            HeaderComponent,
            SearchbarComponent,
            FiltersComponent,
            ActionFiltersComponent,
            ResultsComponent,
            BusinessUnitPanel,
            DateTimePanel,
            FiltersPanel,
        },
        created() {
            if (this.$route.params.criteria) {
                const criteria = decodeAsJsonUriParams(this.$route.params.criteria);

                if (criteria.searchQueryStr) {
                    this.updateSearchQueryStr(criteria.searchQueryStr);
                }
                if (criteria.filters) {
                    this.updateFilters(criteria.filters);
                }
                if (criteria.beginDate) {
                    this.updateBeginDate(moment(criteria.beginDate));
                }
                if (criteria.endDate) {
                    this.updateEndDate(moment(criteria.endDate));
                }
                if (criteria.poslogsTableOptions) {
                    this.updatePoslogsTableOptions(criteria.poslogsTableOptions);
                }
                this.$router.push({name: 'shared'});
            }
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'updateFilters',
                'updateSearchQueryStr',
                'updateBeginDate',
                'updateEndDate',
                'updatePoslogsTableOptions'
            ])
        }
    }
</script>
